<div
  [class.d-none]="loading"
  class="card-body tw-flex-center tw-px-0 flex-column"
>
  <div class="chart-container">
    <canvas [id]="chartId">{{ chart }}</canvas>
  </div>

  <!-- preloading -->
  <div class="row tw-justify-center" *ngIf="loading">
    <div class="tw-mt-[23px] tw-w-full tw-justify-center">
      <div class="tw-flex tw-my-2 tw-items-center tw-justify-center">
        <div class="bg-preloading tw-mx-2 titr-preloading"></div>
      </div>
    </div>
    <div class="tw-w-full bg-preloading Rectangle-chart-preloading"></div>
  </div>
</div>

<!-- preloading -->
<!-- <div class="row tw-justify-center" [class.d-none]="!loading || isEmpty">
  <div class="tw-w-full">
    <div class="tw-flex row tw-my-2 tw-items-center tw-justify-center flex-column">
      <div class="bg-preloading tw-mx-2 titr-preloading tw-w-full tw-mb-2"></div>
      <div class="bg-preloading tw-mx-2 titr-preloading tw-w-full"></div>
    </div>
  </div>
  <div class="bg-preloading circle-chart-preloading tw-w-full"></div>
</div> -->
